import DOMPurify from 'isomorphic-dompurify';

export function $parseErrorMessage(
  error: unknown,
  defaultMessage: string = 'An error occurred.',
): string {
  if (typeof error === 'object' && error !== null && 'message' in error) {
    return String((error as { message?: unknown }).message ?? defaultMessage);
  } else if (typeof error === 'string') {
    return error;
  }

  return defaultMessage;
}

export function $sanitizeHtml(html: string | undefined): string {
  if (!html) return '';

  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
  });
}

export function $stripHtml(html: string | undefined): string {
  if (!html) return '';

  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: [],
  }).trim();
}
